export const trackCustomEvent = (
  category = '',
  action = '',
  label = '',
  value = null,
) => {
  try {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'customEvent',
      action,
      category,
      label,
      value,
    };
    if (value) {
      data.value = value;
    }
    window.dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};

export const trackVirtualPageView = (
  pageUrl = '',
) => {
  try {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'virtualPageEvent',
      pageUrl,
    };
    window.dataLayer.push(data);
  } catch (e) {
    console.log(e);
  }
};
